import React, { useState, useEffect, useRef } from 'react';
import './ApplicantsNotes.css';
import { Link } from 'react-router-dom';
import GetJobId from '../../../_utilities/GetJobId';
import { useDispatch, useSelector } from 'react-redux';
import CkEditor from '../../../components/CkEditor/CkEditor';
import { getUserDetails } from '../../../_utilities/getUserInfo';
import { AddNotesillus } from '../../../Icons/AddNotesillus';
import { updateSnackbar } from '../../../_redux/SnackbarSlice';
import * as _ser from '../../../_redux/_services/ApplicantsSlice';
import { MenuItem, Select, Button, Stack } from '@mui/material';
import RightSideBar from '../../../components/Rightsidebar/RightSideBar';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import * as _projectSer from '../../../_redux/_services/ProjectsSlice';

const initalState = { data: null, message: '', isloader: true };

const AddApplicantsNotes = ({
  onReceivePropsHandler,
  noteState,
  selectedNote,
}) => {
  return (
    <RightSideBar
      componentData={
        <ComponentRenderData
          noteState={noteState}
          selectedNote={selectedNote}
          onReceivechildProps={onReceivePropsHandler}
        />
      }
      componentLayout={
        noteState === 'Create' ? pannelAddNotesobj : pannelEditNotesobj
      }
      footerImg={noteState === 'Create' ? <AddNotesillus /> : <AddNotesillus />}
      onReceiveProps={onReceivePropsHandler}
    />
  );
};

const ComponentRenderData = (props) => {
  const dispatch = useDispatch();
  const [textValue, setTextValue] = useState(' ');
  const [noteType, setnoteType] = useState('Call');
  const [selectedProject, setSelectedProject] = useState('');
  const [projectsList, setProjectsList] = useState([]);
  const [showEditor, setShowEditor] = useState(false);
  const [disableSubmitBtn, setDisableSubmitBtn] = React.useState(false);

  const getJobId = GetJobId();

  const code = useSelector((state) => state.AddApplicantNotes.data);
  const updateCode = useSelector((state) => state.EditApplicantNotes.data);
  const projects = useSelector((state) => state.GetProjectsByApplicantId.data);

  useEffect(() => {
    if (getJobId) {
      dispatch(_projectSer.getProjectsByApplicantIdAsync(getJobId));
    }
  }, [getJobId]);

  useEffect(() => {
    if (projects) {
      if (Array.isArray(projects)) {
        setProjectsList(projects);
      } else if (projects.rows && Array.isArray(projects.rows)) {
        setProjectsList(projects.rows);
      } else if (projects.projects && Array.isArray(projects.projects)) {
        setProjectsList(projects.projects);
      }
    } else {
      setProjectsList([]);
    }
  }, [projects]);

  useEffect(() => {
    if (props.selectedNote !== null && props.noteState !== 'Create') {
      setnoteType(props.selectedNote.noteType);
      setTextValue(props.selectedNote.notes);
      setSelectedProject(props.selectedNote.subModuleId || props.selectedNote.projectId || '');
      setShowEditor(true);
    } else {
      setnoteType('Call');
      setTextValue(' ');
      setSelectedProject('');
      setShowEditor(true);
    }
  }, [props.noteState, props.selectedNote]);

  useEffect(() => {
    console.log('textValue +++', textValue);
  }, [textValue]);

  const HandleSubmit = async (event) => {
    event.preventDefault();
    if (textValue.trim().length > 0 && textValue !== ' ') {
      if (noteType === 'Public' && !selectedProject) {
        dispatch(updateSnackbar({ type: 'error', message: 'Project is required' }));
        return;
      }
      setDisableSubmitBtn(true);
      const userInfo = await getUserDetails();
      let obj = {
        notes: textValue,
        noteType: noteType,
        moduleType: 'applicants',
        moduleId: getJobId,
        userId: userInfo.userId,
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
      };
      obj.subModuleId = noteType === 'Public' ? (selectedProject || null) : null;
      if (props.noteState === 'Create') {
        dispatch(_ser.addNotesAsync(obj))
          .then(() => {
            setDisableSubmitBtn(false);
          })
          .catch(() => {
            setDisableSubmitBtn(false);
          });
      } else {
        obj['id'] = props.selectedNote.id;
        dispatch(_ser.editNotesAsync(obj))
          .then(() => {
            setDisableSubmitBtn(false);
          })
          .catch(() => {
            setDisableSubmitBtn(false);
          });
      }
    } else {
      dispatch(updateSnackbar({ type: 'error', message: 'Please add notes' }));
    }
  };

  useEffect(() => {
    if (code === 200) {
      setTextValue('');
      handleReset();
      dispatch(_ser.addNotesStartReducer(initalState));
      props.onReceivechildProps(false, true);
    }
  }, [code]);

  useEffect(() => {
    if (updateCode === 200) {
      setTextValue('');
      handleReset();
      dispatch(_ser.editNotesStartReducer(initalState));
      props.onReceivechildProps(false, true);
    }
  }, [updateCode]);

  const handleChange = (value, type) => {
    setTextValue(value.data);
  };

  const handleChange1 = (event) => {
    setnoteType(event.target.value);
  };

  const formRef = useRef(null);

  const handleReset = () => {
    formRef.current.reset();
    setnoteType('Call');
    setTextValue('');
    setSelectedProject('');
    props.onReceivechildProps(false, false);
  };

  return (
    <>
      <form ref={formRef}>
        <div className="note-field-row">
          <div className="note-field-label">Note Type</div>
          <Select
            className="typeselectbutton"
            value={noteType}
            onChange={handleChange1}
            autoComplete="off"
          >
            <MenuItem value={'Call'}>Call</MenuItem>
            <MenuItem value={'E-mail'}>E-mail</MenuItem>
            <MenuItem value={'Public'}>Public</MenuItem>
          </Select>
        </div>
          {noteType === "Public" && projectsList.length > 0 && (
            <div className="public-note-warning">
              <InfoOutlinedIcon style={{ color: '#FAAD14', fontSize: '18px', flexShrink: 0, marginTop: '-60px' }} />
              <span className="public-note-warning-text">
                Public notes are visible to all internal recruiters and external collaborators associated with this project through shared project links. Both recruiters and external collaborators can add and view public notes for project-related communication and updates.
              </span>
            </div>
          )}
        {noteType === "Public" && (
          <>
            {projectsList.length === 0 ? (
              <div className="public-note-error">No project linked to this Applicant</div>
            ) : (
              <div className="note-field-row">
                <div className="note-field-label">Select project</div>
                <Select
                  className="typeselectbutton"
                  value={selectedProject}
                  onChange={(e) => {setSelectedProject(e.target.value)}}
                  autoComplete="off"
                  displayEmpty
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 250,
                        width: 200,
                        maxWidth: 200,
                      },
                    },
                  }}
                >
                  <MenuItem value="" disabled style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                    <em>Select Project</em>
                  </MenuItem>
                  {projectsList?.map((project) => (
                    <MenuItem
                      key={project.projectId}
                      value={project.projectId}
                      style={{ whiteSpace: "normal", wordBreak: "break-word" }}
                    >
                      {project.name || project.projectCode}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            )}
          </>
        )}

        <div>
          <div id="jobDescForSMnew">
            {showEditor === true && (
              <CkEditor
                data={textValue}
                initRawData={textValue}
                autoComplete="off"
                name="note"
                isReadonly={false}
                onUpdatehandler={(update) => handleChange(update, 'note')}
              />
            )}
          </div>
        </div>

        <div className="notes-cancelsavebuttons">
          <Stack spacing={2} direction="row">
            <Button
              className="notecancelbtn"
              variant="text"
              sx={{ color: '#FF0000' }}
              type="reset"
              onClick={handleReset}
              size="small"
            >
              <Link
                href="#"
                style={{ color: 'red', fontSize: '14px' }}
                underline="always"
              >
                Cancel
              </Link>
            </Button>
            <Button
              className="notes-savebtn"
              variant="contained"
              style={{ color: '#3B4046', borderRadius: '10px' }}
              type="submit"
              onClick={HandleSubmit}
              size="small"
            >
              {props.noteState === 'Create' ? 'Save' : 'Update'}
            </Button>
          </Stack>
        </div>
      </form>
    </>
  );
};
export default AddApplicantsNotes;

const pannelAddNotesobj = {
  title: 'Add Notes',
  description: '',
  bgImage: '',
};

const pannelEditNotesobj = {
  title: 'Edit Notes',
  description: '',
  bgImage: '',
};
